import * as firebase from 'firebase'
import {tidyObj} from "../helpers.js"
import { Store } from 'vuex';


export default {
  state: {
    actions:[],
     
      },
  mutations: {
    setAction(state,payload){
      var found=false;
      for(var i in state.actions ){
        if(state.actions[i].id==payload.id){
          found=true
          //state.actions[i]=payload.content
        } 
      }
      if(!found){
        state.actions.push(payload.content)
      }
    }
  },
  actions: {
    async loadAction({ commit },payload){
      console.log("DO LOAD",payload)
      let data
      let tidy
      var db = firebase.firestore();
      var docRef = db.collection("Actions").doc(payload)
      await docRef.get().then(function(doc) {
        data=doc.data()
        data.id=payload
        tidy={id:payload,content:tidyObj(data)}
        console.log("LOADED Action",data)
          commit('loadingText',false)
          commit('setAction',tidy) 
          return tidy
          //commit('setCurrentAction',payload) 
      }).catch(function(error) {
          console.log("Error getting document:", error);
          commit('loadingText',false)
        });
    },
  },
  getters: {
    getAction: state => id => {
        for(var action in state.actions){
            if(state.actions[action].id==id){
                return state.actions[action]
            }
        }
        return null
    },
    getActions(state){
      return state.actions
    }
  }
}

